import { createAxiosClient } from '@atlassian/temp-client-utils';
import { ProductSubscriptionsWrapper } from '../../../../types';
import { UUID_REGEX } from '@css-xp/ppc-constants';
import { RegexPatterns } from '@atlassian/cssxp-typescommon';

const bffClient = createAxiosClient({ baseURL: '/api/1', timeout: 40000 }, '');

interface FetchEntitlementsForEntityWithContactEmailsPayload {
  entity: string;
  emails: string[];
}

export const fetchEntitlementsForEntityWithContactEmails = async (
  payload: FetchEntitlementsForEntityWithContactEmailsPayload
): Promise<ProductSubscriptionsWrapper> => {
  const validateResponse = await bffClient.post('/transfer/fetch-entitlements', payload);
  return validateResponse.data;
};

export const processEntity = (siteOrEntNumberOrOrgId: string | undefined, isValidatingOrgEnabled = false) => {
  const withHttp = (url: string) => (!/^https?:\/\//i.test(url) ? `https://${url}` : url);
  const { CCP_ENTITLEMENT_PATTERN, CLOUD_SITE_PROD, CLOUD_SITE_STG } = RegexPatterns;
  const entitlementRegex = new RegExp(CCP_ENTITLEMENT_PATTERN);
  const cloudSiteStagingUrlRegex = new RegExp(CLOUD_SITE_STG);
  const cloudSiteProdUrlRegex = new RegExp(CLOUD_SITE_PROD);

  if (!siteOrEntNumberOrOrgId) {
    return {
      isValid: false,
    };
  }

  siteOrEntNumberOrOrgId = siteOrEntNumberOrOrgId.trim();

  const isValidEntitlementNumber = entitlementRegex.test(siteOrEntNumberOrOrgId);
  if (isValidEntitlementNumber) {
    return {
      isValid: true,
      entitlementNumber: siteOrEntNumberOrOrgId,
    };
  }
  if (isValidatingOrgEnabled) {
    // NOTE: We are not using UUID pattern. For now, commenting out the code for UUID test.
    // const isValidOrgId = UUID_REGEX.test(siteOrEntNumberOrOrgId);
    const isValidOrgId = false;
    if (isValidOrgId) {
      return {
        isValid: true,
        orgId: siteOrEntNumberOrOrgId,
      };
    }
  }
  const isValidUrl =
    cloudSiteStagingUrlRegex.test(siteOrEntNumberOrOrgId) || cloudSiteProdUrlRegex.test(siteOrEntNumberOrOrgId);
  try {
    const urlObj = new URL(withHttp(siteOrEntNumberOrOrgId));
    if (isValidUrl) {
      return {
        isValid: true,
        siteURL: urlObj.host,
      };
    }
  } catch (e) {
    return {
      isValid: false,
    };
  }
  return {
    isValid: false,
  };
};

export const validateEntity = async ({
  entity,
  transactionAccountId,
}: {
  entity?: string;
  transactionAccountId: string;
}) => {
  const validateResponse = await bffClient.post('/transfer/validate-entity', { entity, transactionAccountId });
  return validateResponse.data;
};
